import { processStages } from './adminWidgets'

const adminSections = {
    forms: { key: 'forms', name: '{{lang}}Forms', img: '/images/icons/layout.png' },

    // category: { key: 'category', name: 'Categories options', },
    // blog: { key: 'blog', name: 'blogs options', },
    // video: { key: 'video', name: 'videos options', },
    // podcast: { key: 'podcast', name: 'podcasts options', },
    // series: { key: 'series', name: 'series options', },
    // froum: { key: 'settings', name: '{{lang}}Basic settings', img: '/images/icons3/setting-(1).png' },

    report: { key: 'report', name: '{{lang}}Reports', img: '/images/icons/file.png' },

    // categories: { key: 'operation', name: '{{lang}}Operation', img: '/images/icons/computer.png' },
    // product: { key: 'products', name: 'Products option' },
    // messages: { key: 'messages', name: 'messages option' }
}

const adminPages = {


    forms: {
        key: 'forms',
        title: '{{lang}}customer form',
        description: '{{lang}}customer form list',
        // fetchUrl: 'getForms',
        // hideAddButton: true,
        actions: {
            edit: { key: "edit", label: '{{lang}}edit', color: '#fff', function: "openEditModal", permission: 'view' },
            remove: { key: "remove", label: '{{lang}}remove', bg: '#d91111', color: '#fff', function: "openRemoveModal", permission: 'delete' }
        },
        fetchUrl: 'getRecords',
        addUrl: 'postRecord',
        editUrl: 'postRecord',
        removeUrl: 'removeRecord',
        // addUrl: 'addForm',
        // editUrl: 'addForm',
        // removeUrl: 'removeForm',
        // options: { noAddNew: true },
        // helperKey: 'values',
        pageType: 'form',
        parent: 'forms',
        // options: {},
        sort: { 'cDate': -1 },
        postBody: { applet: '{{applet}}' },
        // addNew: -1,
        importAPIName: [{ key: 'values.model', title: "values.name", value: '_id', schema: 'records' }, { key: 'values.colour', title: "values.name", value: '_id', schema: 'records' }, { key: 'creator', title: "name", value: '_id', schema: 'employees' }, { key: 'applet', title: "name", value: '_id', schema: 'applets' }, { key: 'values.date', isDate: true }, { key: 'values.firstFollowDate', isDate: true }, { key: 'values.secondFollowDate', isDate: true }, { key: 'values.thirdFollowDate', isDate: true }, { key: 'values.forthFollowDate', isDate: true }],
        // extra: { export: { url: 'equipmentExcelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' }, import: { schema: 'equipments', name: 'import', function: 'openImport', icon: '/images/eye.svg' } },
        extra: {
            import: { schema: 'records', name: '{{lang}}Import', function: 'openImport', icon: '/images/eye.svg' },
            export: { url: 'ExelEquipment', name: '{{lang}}export', function: 'openExport', icon: '/images/eye.svg' }
        },
        // addNew: '/admin/recordInfo',
        image: '/images/kheiry/people.png',
        populates: [{ key: 'values.model', model: 'records', select: ['values.name'] }, { key: 'values.colour', model: 'records', select: ['values.name'] }, { key: 'creator', model: 'employees', select: ['name'] }, { key: 'applet', model: 'applets', select: ['name'] }],
        // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
        headers: [
            { col: '6', key: 'values.formId', type: 'TextInput', information: { label: '{{lang}}Form ID', disabled: true, required: false }, showMain: true, inExport: true },

            { col: '6', key: 'values.customerName', type: 'TextInput', information: { label: '{{lang}}Customer Name', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.date', type: 'JalaliDateInput', information: { label: '{{lang}}Date', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.job', type: 'TextInput', information: { label: '{{lang}}Job', disabled: false, required: true }, showMain: false, inExport: true },
            { col: '6', key: 'values.jobDesc', type: 'TextInput', information: { label: '{{lang}}Job Description', disabled: false, required: true }, showMain: false, inExport: true },
            { col: '6', key: 'values.age', type: 'TextInput', information: { label: '{{lang}}Age', disabled: false, required: true }, showMain: false, inExport: true },
            { col: '6', key: 'values.address', type: 'TextInput', information: { label: '{{lang}}Address', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.addressDesc', type: 'TextInput', information: { label: '{{lang}}Address Description', disabled: false, required: true }, showMain: false, inExport: true },
            { col: '6', key: 'values.subCategory', type: 'TextInput', information: { label: '{{lang}}subCategory', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.phoneNumber', type: 'TextInput', information: { label: '{{lang}}Phone', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.purchaseMethod', type: 'SelectInput', information: { label: '{{lang}}purchaseMethod', type: 'local', items: [{ value: 'نقدی', title: 'نقدی' }, { value: 'اقساطی', title: 'اقساطی' }, { value: 'اتو آوات', title: 'اتو آوات' }, { value: 'نقدی / اقساطی', title: 'نقدی / اقساطی' }, { value: 'جایگزنی اقساطی ', title: 'جایگزنی اقساطی ' }, { value: 'جایگزینی نقدی', title: 'جایگزینی نقدی' }, { value: 'خرید فوری / پلاک شده', title: 'خرید فوری / پلاک شده' }, { value: 'تست درایو', title: 'تست درایو' }], isSearchable: true, placeholder: '{{lang}}Select', required: true, disabled: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.prepaymentAmount', type: 'PriceInput', information: { label: '{{lang}}prepaymentAmount', disabled: false, required: true },
            dependencies: [{
                refKey: 'values.purchaseMethod',
                targetKey: 'values.prepaymentAmount',
                conditions: {
                    root: {
                        id: 'root',
                        action: 'or',
                        conditions: {
                            1: { id: 1, source: { value: '@data.values.purchaseMethod' }, operator: { value: '!=' }, target: { value: 'اتو آوات' } },
                        }
                    }
                },
                show: true,
                init: false,
            }],
            showMain: true, inExport: true },
            {
                col: '6',
                key: 'values.approximateCarPrice',
                type: 'PriceInput',
                information: { label: 'قیمت تقریبی خودرو', disabled: false, required: false },
                dependencies: [{
                    refKey: 'values.purchaseMethod',
                    targetKey: 'values.approximateCarPrice',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: '@data.values.purchaseMethod' }, operator: { value: '==' }, target: { value: 'اتو آوات' } },
                            }
                        }
                    },
                    show: true,
                    init: false,
                }],
                showMain: true,
                inExport: true,
            },
            {
                col: '6',
                key: 'values.customerCashAmount',
                type: 'PriceInput',
                information: { label: 'مبلغ نقدی مشتری', disabled: false, required: false },
                dependencies: [{
                    refKey: 'values.purchaseMethod',
                    targetKey: 'values.customerCashAmount',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: '@data.values.purchaseMethod' }, operator: { value: '==' }, target: { value: 'اتو آوات' } },
                            }
                        }
                    },
                    show: true,
                    init: false,
                }],
                showMain: true,
                inExport: true,
            },
            {
                col: '6',
                key: 'values.requestedFacilityAmount',
                type: 'PriceInput',
                information: { label: 'مبلغ تسهیلات درخواستی', disabled: false, required: false },
                dependencies: [{
                    refKey: 'values.purchaseMethod',
                    targetKey: 'values.requestedFacilityAmount',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: '@data.values.purchaseMethod' }, operator: { value: '==' }, target: { value: 'اتو آوات' } },
                            }
                        }
                    },
                    show: true,
                    init: false,
                }],
                showMain: true,
                inExport: true,
            },
            {
                col: '6',
                key: 'values.lastFollowUpResult',
                type: 'SelectInput',
                information: {
                    label: '{{lang}}lastFollowUpResult',
                    type: 'local',
                    items: [
                        { value: 'در حال مذاکره', title: 'در حال مذاکره', color: '#fff', background: 'rgb(0, 122, 255)' },
                        { value: 'در انتظار ثبت', title: 'در انتظار ثبت', color: '#000', background: 'rgb(255, 197, 0)' },
                        { value: 'قرارداد', title: 'قرارداد', color: '#000', background: 'rgb(21, 137, 118)' },
                        { value: 'منصرف شده', title: 'منصرف شده', background: '#ee5050', color: '#fff' },
                        { value: 'کنسل شده', title: 'کنسل شده', background: '#000000 ', color: '#fff' },
                        { value: 'مشتری شده', title: 'مشتری شده', color: '#fff', background: 'rgb(1, 82, 47)' }
                    ],
                    isSearchable: true,
                    placeholder: '{{lang}}Select',
                    required: true
                },
                // dependencies: [
                //     {
                //         refKey: 'values.purchaseMethod',
                //         targetKey: 'values.lastFollowUpResult',
                //         conditions: {
                //             root: {
                //                 id: 'root',
                //                 action: 'or',
                //                 conditions: {
                    //                     1: { id: 1, source: { value: '@data.values.purchaseMethod' }, operator: { value: '==' }, target: { value: 'اتو آوات' } }
                    //                 }
                    //             }
                //         },
                //         show: true,
                //         init: false
                //     }
                // ],
                showMain: true,
                inExport: true
            },
            {
                col: '6',
                key: 'values.salesFlow',
                type: 'SelectInput',
                information: { label: 'نوع قرارداد', type: 'local', items: [{ value: 'cash', title: 'نقدی' }, { value: 'installment', title: 'تسهیلات (آوات)' }, { value: 'exchange', title: 'جایگزنی' }], isSearchable: true, placeholder: '{{lang}}Select', required: true, disabled: false },
                dependencies: [{
                    refKey: 'values.lastFollowUpResult',
                    targetKey: 'values.salesFlow',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: '@data.values.lastFollowUpResult' }, operator: { value: '==' }, target: { value: 'قرارداد' } }
                            }
                        }
                    },
                    show: true,
                    init: false
                }],
                showMain: true,
                inExport: true
            },
           
            {
                col: '6',
                key: 'values.ownerCarModel',
                type: 'TextInput',
                information: { label: '{{lang}}Owner Car Model', disabled: false, required: false },
                dependencies: [{
                    refKey: 'values.purchaseMethod',
                    targetKey: 'values.ownerCarModel',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: '@data.values.purchaseMethod' }, operator: { value: '==' }, target: { value: 'جایگزینی نقدی' } },
                                2: { id: 2, source: { value: '@data.values.purchaseMethod' }, operator: { value: '==' }, target: { value: 'جایگزنی اقساطی ' } },
                            }
                        }
                    },
                    show: true,
                    init: false,
                }],
                showMain: true,
                inExport: true,
            },
           

            // { col: '6', key: 'values.model', type: 'TextInput', information: { label: '{{lang}}model', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.model', type: 'SelectInput', information: { label: '{{lang}}model', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'cars' }, sort: { 'values.priority': -1 } }, fields: { title: 'values.name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: true, disabled: false }, showMain: true, inExport: true },
            {
                col: '6',
                key: 'values.carName',
                type: 'TextInput',
                information: { label: '{{lang}}Car Name', disabled: true, required: false },
                dependencies: [{
                    refKey: 'values.model',
                    targetKey: 'values.carName',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: '@data.values.model' }, operator: { value: '==' }, target: { value: null } },
                            }
                        }
                    },
                    changeHeader: { key: 'information.disabled', value: true },
                    changeValue: { targetKey: 'values.carName', value: '' },
                    init: false,
                }, {
                    refKey: 'values.model',
                    targetKey: 'values.carName',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'and',
                            conditions: {
                                1: { id: 1, source: { value: '@data.values.model.values.name' }, operator: { value: '==' }, target: { value: 'سایر' } },
                            }
                        }
                    },
                    changeHeader: { key: 'information.disabled', value: false },
                    changeValue: { targetKey: 'values.carName', value: '' },
                    init: false,
                }, {
                    refKey: 'values.model',
                    targetKey: 'values.carName',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'and',
                            conditions: {
                                1: { id: 1, source: { value: '@data.values.model.values.name' }, operator: { value: '!=' }, target: { value: 'سایر' } },
                                2: { id: 2, source: { value: '@data.values.model.values.name' }, operator: { value: '!=' }, target: { value: null } },
                                3: { id: 3, source: { value: '@data.values.model.values.name' }, operator: { value: '!=' }, target: { value: '' } },
                            }
                        }
                    },
                    changeHeader: { key: 'information.disabled', value: true },
                    changeValue: { targetKey: 'values.carName', value: '@data.values.model.values.name' },
                    init: false,
                }],
                showMain: true,
                inExport: true,
            },

            { col: '6', key: 'values.colour', type: 'SelectInput', information: { label: '{{lang}}vehicleColour', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'colors' } }, fields: { title: 'values.name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: true, disabled: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.firstFollowDate', type: 'JalaliDateInput', information: { label: '{{lang}}firstFollowDate', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.secondFollowDate', type: 'JalaliDateInput', information: { label: '{{lang}}secondFollowDate', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.thirdFollowDate', type: 'JalaliDateInput', information: { label: '{{lang}}thirdFollowDate', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.forthFollowDate', type: 'JalaliDateInput', information: { label: '{{lang}}forthFollowDate', disabled: false, required: false }, showMain: false, inExport: true },

            // { col: '6', key: 'values.purchaseMethod', type: 'TextInput', information: { label: '{{lang}}purchaseMethod', disabled: false, required: false }, showMain: true, inExport: true },

            // { col: '6', key: 'values.howHeardAboutUs', type: 'TextInput', information: { label: '{{lang}}howHeardAboutUs', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.howHeardAboutUs', type: 'SelectInput', information: { label: '{{lang}}howHeardAboutUs', type: 'local', items: [{ value: 'تلفنی', title: 'تلفنی' }, { value: 'حضوری', title: 'حضوری' }, { value: 'آگهی دیوار', title: 'آگهی دیوار' }, { value: 'آگهی باما', title: 'آگهی باما' }, { value: 'وبسایت', title: 'وبسایت' }, { value: 'اینستاگرام', title: 'اینستاگرام' }, { value: 'پیامک', title: 'پیامک' }, { value: 'خرید قبلی', title: 'خرید قبلی' }, { value: 'معرف', title: 'معرف' }, { value: 'مشتریان قدیمی', title: 'مشتریان قدیمی' }, { value: 'دوستان و آشنایان', title: 'دوستان و آشنایان' }], isSearchable: true, placeholder: '{{lang}}Select', required: true }, showMain: true, inExport: true },

            // { col: '6', key: 'values.visitMethod', type: 'TextInput', information: { label: '{{lang}}visitMethod', disabled: false, required: false }, showMain: false, inExport: true },
            { col: '6', key: 'values.visitMethod', type: 'SelectInput', information: { label: '{{lang}}visitMethod', type: 'local', items: [{ value: 'تلفنی', title: 'تلفنی' }, { value: 'حضوری', title: 'حضوری' }], isSearchable: true, placeholder: '{{lang}}Select', required: true }, showMain: true, inExport: true },

            { col: '6', key: 'values.nationalId', type: 'NumberInput', information: { label: '{{lang}}nationalId', disabled: false, required: true, maxLength: 10 }, showMain: false, inExport: true },
            // { col: '6', key: 'values.colour', type: 'TextInput', information: { label: '{{lang}}vehicleColour', disabled: false, required: false }, showMain: true, inExport: true },

            // { col: '12', key: 'values.lastFollowUpResult', type: 'TextAreaInput', information: { label: '{{lang}}lastFollowUpResult', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.testDrive', type: 'TextInput', information: { label: '{{lang}}testDrive', disabled: false, required: false }, showMain: true, inExport: true },


            { col: '12', key: 'values.additionalNotes', type: 'TextAreaInput', information: { label: '{{lang}}additionalNotes', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'applet', type: 'SelectInput', information: { label: '{{lang}}branch', updateAfterSelect: true, isSearchable: false, address: 'getApplets', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false }, showMain: false, hideComponent: true, hideInList: true, inExport: true },
            // { col: '6', key: 'applet', type: 'TextInput', information: { label: '{{lang}}branch', disabled: false, required: false }, showMain: false, hideComponent: true, inExport: true },
            // { col: '6', key: 'creator', type: 'TextInput', information: { label: '{{lang}}salesperson', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'creator', type: 'SelectInput', information: { label: '{{lang}}salesperson', updateAfterSelect: true, isSearchable: false, address: 'employeeGetAll', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false, disabled: true, restricted: true, defaultUser: true }, showMain: true, inExport: true },
            // { col: '6', key: 'followUpDate', type: 'DateInput', information: { label: '{{lang}}Record date', disabled: false, required: true }, showMain: true, inExport: true },
            // { col: '6', key: 'recordGroup', type: 'SelectInput', information: { label: '{{lang}}Records group', updateAfterSelect: true, isSearchable: false, address: 'getRecordsGroup', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}select', required: false }, showMain: false },
            // { col: '6', key: 'validityDate', type: 'DateInput', information: { label: '{{lang}}Validity date', disabled: false, required: true }, showMain: true, inExport: true },
            // { col: '6', key: 'reviewPeriod', type: 'NumberInput', information: { label: '{{lang}}Review period', disabled: false, required: true }, showMain: true, inExport: true },
            // { col: '6', type: 'SelectInput', key: 'repetitionPeriod', information: { label: '{{lang}}Repetition period', type: 'local', items: [{ value: 'day', title: 'یک روز' }, { value: 'week', title: '{{lang}}A week' }, { value: 'Month', title: '{{lang}}One Month' }, { value: 'Year', title: 'One year' }], isSearchable: true, placeholder: '{{lang}}Select', required: true }, showMain: true },
            // { col: '6', key: 'code', type: 'SlidesInput', information: { label: '{{lang}}Code', disabled: true, required: false, generateId: true, }, showMain: true, inExport: true },
            // {
            //     key: 'code',
            //     type: 'SlidesInput',
            //     information: {
            //         label: '{{lang}}Code',
            //         updateAfterSelect: true,
            //         isSearchable: false,
            //         fields: { title: 'name', value: '_id' },
            //         type: 'api',
            //         isSearchable: false,
            //         placeholder: '{{lang}}slides',
            //         required: false
            //     },

            //     showMain: false

            // },
            // { col: '6', key: 'secondCode', type: 'TextInput', information: { label: '{{lang}}The second code of the document', disabled: false, required: true }, showMain: true, inExport: true },
            // { col: '12', key: 'files', type: 'FileInput', information: { label: '{{lang}}Files', single: false, placeholder: '{{lang}}Attachments', required: false }, showMain: false },
        ],

    },


   
    avat: {
        key: 'avat',
        page: 'forms',
        title: 'قراردادهای جاری',
        description: '{{lang}}avat List',
        actions: {
            cancelOrder: { key: "cancelOrder", label: '{{lang}}Cancel Order', bg: '#d91111', color: '#fff', function: "openCancelOrderModal", permission: 'delete' },
            seeStatus: { key: "seeStatus", label: '{{lang}}See Orders Status', color: '#fff', function: "openStatusModal", permission: 'view' },
            edit: { key: "edit", label: '{{lang}}edit', color: '#fff', function: "openEditModal", permission: 'view' },
        },
        fetchUrl: 'getRecords',
        addUrl: 'postRecord',
        editUrl: 'postRecord',
        removeUrl: 'removeRecord',
        pageType: 'form',
        parent: 'forms',
        sort: { 'uDate': -1 },
        addNew: -1,
        noAddNew: true,
        postBody: {
            applet: '{{applet}}',
            'values.lastFollowUpResult':'قرارداد'
        },
        image: '/images/kheiry/people.png',
        processStages: processStages,
        populates: [
            { key: 'values.representor', model: 'employees', select: ['name'] },
            { key: 'creator', model: 'employees', select: ['name'] },
            { key: 'applet', model: 'applets', select: ['name'] },
            { key: 'values.model', model: 'records', select: ['values.name'] },
        ],
        headers: [
            { col: '6', key: 'values.formId', type: 'TextInput', information: { label: '{{lang}}Form ID', disabled: true, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.purchaseMethod', type: 'SelectInput', information: { label: '{{lang}}purchaseMethod', type: 'local', items: [{ value: 'نقدی', title: 'نقدی' }, { value: 'اقساطی', title: 'اقساطی' }, { value: 'اتو آوات', title: 'اتو آوات' }, { value: 'نقدی / اقساطی', title: 'نقدی / اقساطی' }, { value: 'جایگزنی اقساطی ', title: 'جایگزنی اقساطی ' }, { value: 'جایگزینی نقدی', title: 'جایگزینی نقدی' }, { value: 'خرید فوری / پلاک شده', title: 'خرید فوری / پلاک شده' }, { value: 'تست درایو', title: 'تست درایو' }], isSearchable: true, placeholder: '{{lang}}Select', required: true, disabled: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.customerName', type: 'TextInput', information: { label: '{{lang}}Customer Name', disabled: true, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.model', type: 'SelectInput', information: { label: '{{lang}}model', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'cars' }, sort: { 'values.priority': -1 } }, fields: { title: 'values.name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: true, disabled: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.phoneNumber', type: 'TextInput', information: { label: '{{lang}}Phone', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.date', type: 'JalaliDateInput', information: { label: '{{lang}}Date', disabled: true, required: false, time: true }, showMain: true, inExport: true },
            { col: '6', key: 'uDate', type: 'JalaliDateInput', information: { label: '{{lang}}Last Update Date', disabled: true, required: false, time: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.currentStatus', type: 'ProfessionalStatusInput', information: { label: '{{lang}}Current Status', disabled: false, required: false }, showMain: true, inExport: true },
        ],
    },
    
   
    // adminLogs: {
    //     key: "adminLogs",
    //     title: '{{lang}}Admin Logs',
    //     description: '{{lang}}Admin Logs List',
    //     fetchUrl: 'getLogs',
    //     // addUrl: 'addEmployee',
    //     // editUrl: 'addEmployee',
    //     // removeUrl: 'removeEmployee',
    //     pageType: 'form',
    //     page: 'logs',
    //     parent: 'whthoutParent',
    //     postBody: {},

    //     addNew: -1,
    //     options: { noAddNew: true },
    //     actions: {
    //         edit: { key: "edit", label: '{{lang}}view', color: '#fff', function: "openEditModal", permission: 'view' },
    //     },
    //     // tabs: [
    //     //     { title: 'Admins', filter: { "role": 'admin' } },
    //     //     { title: 'Users', filter: { "role": 'user' } },

    //     // ],

    //     image: '/images/kheiry/lock.png',
    //     headers: [
    //         { type: 'TextInput', key: 'name', information: { label: '{{lang}}Name', disabled: true }, showMain: true },
    //         { type: 'TextInput', key: 'phone', information: { label: '{{lang}}Phone', disabled: true }, showMain: true },
    //         { type: 'TextInput', key: 'committer', information: { label: '{{lang}}committed by', disabled: true }, showMain: true },
    //         { type: 'TextInput', key: 'ip', information: { label: '{{lang}}ip', disabled: true }, showMain: true },
    //         { type: 'TextAreaInput', key: 'message', information: { label: '{{lang}}Message', disabled: true }, showMain: true },
    //         { type: 'DateInput', key: 'cDate', information: { label: '{{lang}}Date/Time', time: true, disabled: true }, showMain: true },

    //         { type: 'TextInput', key: 'type', information: { label: '{{lang}}Type', disabled: true }, showMain: true },

    //     ],
    // },

    contracts: {
        key: 'contracts',
        page: 'forms',
        title: '{{lang}}Contracts',
        description: '{{lang}}Contracts List',
        actions: {
            edit: { key: "edit", label: '{{lang}}edit', color: '#fff', function: "openEditModal", permission: 'view' },
        },
        fetchUrl: 'getRecords',
        addUrl: 'postRecord',
        editUrl: 'postRecord',
        removeUrl: 'removeRecord',
        pageType: 'form',
        parent: 'forms',
        sort: { 'uDate': -1 },
        addNew: -1,
        noAddNew: true,
        postBody: {
            applet: '{{applet}}',
            'values.lastFollowUpResult': 'مشتری شده',
            'values.purchaseMethod': {$ne: 'اتو آوات'}
        },
        image: '/images/kheiry/people.png',
        processStages: processStages,
        populates: [
            { key: 'values.representor', model: 'employees', select: ['name'] },
            { key: 'creator', model: 'employees', select: ['name'] },
            { key: 'applet', model: 'applets', select: ['name'] },
            { key: 'values.model', model: 'records', select: ['values.name'] },
        ],
        headers: [
            { col: '6', key: 'values.formId', type: 'TextInput', information: { label: '{{lang}}Form ID', disabled: true, required: false }, showMain: true, inExport: true },
            {
                type: 'SubformInput',
                key: 'values.followUp',
                col: '12',
                information: {
                    label: 'Features List',
                    headers: [
                        { col: '3', key: 'date', type: 'JalaliDateInput', information: { label: '{{lang}}Date', disabled: false, required: false, time: true }, showMain: true, inExport: true },
                        { col: '9', key: 'description', type: 'TextAreaInput', showMain: true, information: { label: '{{lang}}description', disabled: false, required: false }, },

                        // { type: 'SelectInput', key: 'country', col: '4', information: { label: 'country', placeholder: '{{lang}}country', type: 'api', fields: { value: '_id', title: 'name' }, address: 'countriesGetAll', filter: {} }, showMain: true, fullCol: true },
                    ],

                    placeholder: '{{lang}}country discount',
                    required: false,
                },

                showMain: false
            },
            { col: '6', key: 'values.customerName', type: 'TextInput', information: { label: '{{lang}}Customer Name', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.date', type: 'JalaliDateInput', information: { label: '{{lang}}Date', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.job', type: 'TextInput', information: { label: '{{lang}}Job', disabled: false, required: true }, showMain: false, inExport: true },
            { col: '6', key: 'values.jobDesc', type: 'TextInput', information: { label: '{{lang}}Job Description', disabled: false, required: true }, showMain: false, inExport: true },
            { col: '6', key: 'values.age', type: 'TextInput', information: { label: '{{lang}}Age', disabled: false, required: true }, showMain: false, inExport: true },
            { col: '6', key: 'values.address', type: 'TextInput', information: { label: '{{lang}}Address', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.addressDesc', type: 'TextInput', information: { label: '{{lang}}Address Description', disabled: false, required: true }, showMain: false, inExport: true },
            { col: '6', key: 'values.subCategory', type: 'TextInput', information: { label: '{{lang}}subCategory', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.phoneNumber', type: 'TextInput', information: { label: '{{lang}}Phone', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.purchaseMethod', type: 'SelectInput', information: { label: '{{lang}}purchaseMethod', type: 'local', items: [{ value: 'نقدی', title: 'نقدی' }, { value: 'اقساطی', title: 'اقساطی' }, { value: 'اتو آوات', title: 'اتو آوات' }, { value: 'نقدی / اقساطی', title: 'نقدی / اقساطی' }, { value: 'جایگزنی اقساطی ', title: 'جایگزنی اقساطی ' }, { value: 'جایگزینی نقدی', title: 'جایگزینی نقدی' }, { value: 'خرید فوری / پلاک شده', title: 'خرید فوری / پلاک شده' }, { value: 'تست درایو', title: 'تست درایو' }], isSearchable: true, placeholder: '{{lang}}Select', required: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.prepaymentAmount', type: 'PriceInput', information: { label: '{{lang}}prepaymentAmount', disabled: false, required: true },
            dependencies: [{
                refKey: 'values.purchaseMethod',
                targetKey: 'values.prepaymentAmount',
                conditions: {
                    root: {
                        id: 'root',
                        action: 'or',
                        conditions: {
                            1: { id: 1, source: { value: '@data.values.purchaseMethod' }, operator: { value: '!=' }, target: { value: 'اتو آوات' } },
                        }
                    }
                },
                show: true,
                init: false,
            }],
            showMain: true, inExport: true },
            {
                col: '6',
                key: 'values.approximateCarPrice',
                type: 'PriceInput',
                information: { label: 'قیمت تقریبی خودرو', disabled: false, required: false },
                dependencies: [{
                    refKey: 'values.purchaseMethod',
                    targetKey: 'values.approximateCarPrice',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: '@data.values.purchaseMethod' }, operator: { value: '==' }, target: { value: 'اتو آوات' } },
                            }
                        }
                    },
                    show: true,
                    init: false,
                }],
                showMain: true,
                inExport: true,
            },
            {
                col: '6',
                key: 'values.customerCashAmount',
                type: 'PriceInput',
                information: { label: 'مبلغ نقدی مشتری', disabled: false, required: false },
                dependencies: [{
                    refKey: 'values.purchaseMethod',
                    targetKey: 'values.customerCashAmount',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: '@data.values.purchaseMethod' }, operator: { value: '==' }, target: { value: 'اتو آوات' } },
                            }
                        }
                    },
                    show: true,
                    init: false,
                }],
                showMain: true,
                inExport: true,
            },
            {
                col: '6',
                key: 'values.requestedFacilityAmount',
                type: 'PriceInput',
                information: { label: 'مبلغ تسهیلات درخواستی', disabled: false, required: false },
                dependencies: [{
                    refKey: 'values.purchaseMethod',
                    targetKey: 'values.requestedFacilityAmount',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'or',
                            conditions: {
                                1: { id: 1, source: { value: '@data.values.purchaseMethod' }, operator: { value: '==' }, target: { value: 'اتو آوات' } },
                            }
                        }
                    },
                    show: true,
                    init: false,
                }],
                showMain: true,
                inExport: true,
            },
            // { col: '6', key: 'values.model', type: 'TextInput', information: { label: '{{lang}}model', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.model', type: 'SelectInput', information: { label: '{{lang}}model', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'cars' }, sort: { 'values.priority': -1 } }, fields: { title: 'values.name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.colour', type: 'SelectInput', information: { label: '{{lang}}vehicleColour', updateAfterSelect: true, isSearchable: false, address: 'getRecords', filter: { filter: { frame: 'colors' } }, fields: { title: 'values.name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: true }, showMain: true, inExport: true },
            
        ],
    },
    leadsreport: {
        key: 'leadsreport',
        title: '{{lang}}گزارش کلی لیدها',
        description: '{{lang}}گزارش کلی لیدها',
        // fetchUrl: 'homePageChartDocs',
        // addUrl: 'postCreateDocument',
        // editUrl: 'postCreateDocument',
        // removeUrl: 'removeCreateDocument',
        options: { noAddNew: true },
        pageType: 'leadsreport',
        document: true,
        parent: 'cartable',
        options: {},
        // hidePage: true,
        hideSection: true,
        hideActions: true,
        // tabBar: [
        //     { title: "{{lang}}Document", key: 'document' },
        //     { title: "{{lang}}History", key: 'history' },
        //     { title: "{{lang}}correction", key: 'correction' },
        // ],
        // actions: {
        //     post: { key: "post", label: '{{lang}}post', color: '#fff', function: "postCreateDocument", permission: 'create' },
        // },

        image: '/images/kheiry/jamboard.png',
        // sections: [
        //     {
        //         title: "{{lang}}Document", key: 'document',
        //         headers: [
        //             { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Request title', disabled: false, required: true }, showMain: true, inExport: true },
        //             { col: '6', key: 'documentGroup', type: 'SelectInput', information: { label: '{{lang}}Document group', updateAfterSelect: true, isSearchable: false, address: 'getDocumentGroup', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}select', required: false }, showMain: false },
        //             { col: '6', key: 'documentType', type: 'SelectInput', information: { label: '{{lang}}Type of documents', updateAfterSelect: true, isSearchable: false, address: 'getDocumentType', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}select', required: false }, showMain: false },

        //             { col: '6', key: 'files', type: 'FileInput', information: { label: '{{lang}}Files', single: false, placeholder: '{{lang}}Attachments', required: false }, showMain: false },
        //             { col: '12', key: 'description', type: 'EditorInput', information: { label: '{{lang}}Description', disabled: false, required: false }, showMain: true, inExport: true },
        //         ]
        //     },
        // ],
        // headers: [
        //     { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Request title', disabled: false, required: true }, showMain: true, inExport: true },
        //     { col: '6', key: 'documentGroup', type: 'SelectInput', information: { label: '{{lang}}Document group', updateAfterSelect: true, isSearchable: false, address: 'getDocumentGroup', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}select', required: false }, showMain: false },
        //     { col: '6', key: 'documentType', type: 'SelectInput', information: { label: '{{lang}}Type of documents', updateAfterSelect: true, isSearchable: false, address: 'getDocumentType', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: false, placeholder: '{{lang}}select', required: false }, showMain: false },
        //     { col: '12', key: 'description', type: 'EditorInput', information: { label: '{{lang}}Description', disabled: false, required: false }, showMain: true, inExport: true },

        //     { col: '12', key: 'files', type: 'FileInput', information: { label: '{{lang}}Files', single: false, placeholder: '{{lang}}Attachments', required: false }, showMain: false },
        // ],

    },





    leadsstatus: {
        key: 'leadsstatus',
        title: '{{lang}}وضعیت لیدها',
        description: '{{lang}}وضعیت لیدها',
        // fetchUrl: 'homePageChartDocs',
        // addUrl: 'postCreateDocument',
        // editUrl: 'postCreateDocument',
        // removeUrl: 'removeCreateDocument',
        options: { noAddNew: true },
        pageType: 'LeadsStatusReport',
        document: true,
        parent: 'cartable',
        options: {},
        hideSection: true,
        hideActions: true,

        image: '/images/kheiry/jamboard.png',

    },




    hotleads: {
        key: 'hotleads',
        title: '{{lang}}میزان پیش ثبت نام قطعی',
        description: '{{lang}}میزان پیش ثبت نام قطعی',
        // fetchUrl: 'homePageChartDocs',
        // addUrl: 'postCreateDocument',
        // editUrl: 'postCreateDocument',
        // removeUrl: 'removeCreateDocument',
        options: { noAddNew: true },
        pageType: 'hotLeadsReport',
        document: true,
        parent: 'cartable',
        options: {},
        hideSection: true,
        hideActions: true,

        image: '/images/kheiry/jamboard.png',

    },


    permissions: {
        key: 'permissions',
        title: 'دسترسی‌های شعبه',
        description: '{{lang}}Permissions List',
        fetchUrl: 'getPermissions',
        removeUrl: 'removePermission',
        // editUrl: 'addValue',
        // removeUrl: 'removeValue',
        pageType: 'form',
        page: 'permissions',
        parent: 'settings',
        image: '/images/kheiry/locked.png',
        addNew: '../permission',
        hideFilter: true,
        headers: [
            // { key: 'groups', type: 'MultiSelectInput', col: '12', information: { label: '{{lang}}useful.groups', placeholder: '{{lang}}useful.groups', required: false, disabled: true }, showMain: true },
            { key: 'users', type: 'MultiSelectInput', col: '12', information: { label: '{{lang}}Users', fields: { title: 'username', value: '_id' }, placeholder: '{{lang}}useful.users', required: false, disabled: true, showAllInTable: true }, showMain: true },

            { key: 'description', type: 'TextInput', col: '12', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: false, disabled: true }, showMain: true },


        ]
    },


    permission: {
        key: 'permission',
        title: 'permission',
        permissionKey: 'permissions',
        description: 'permission List',
        fetchUrl: 'getPermission',
        addUrl: 'addPermission',
        editUrl: 'addPermission',
        // removeUrl: 'removePermission',
        pageType: 'permissions',
        page: 'permissions',
        permissionRules: ['admin.permissions.create', 'admin.permissions.edit'],
        permissionParent: 'permissions',
        // parent: 'admin',
        hidePage: true,
        image: '/images/covers/dashboards.jpg',

        headers: [
            { type: 'TextInput', key: 'email', information: { label: 'Email', }, showMain: true },
            { key: 'status', type: 'SelectInput', information: { label: 'Status', type: 'local', default: '0', items: [{ title: "unsubscribed", value: '0' }, { title: 'active', value: '1' }] }, settings: { required: false }, showMain: true },
        ]
    },


}


export { adminPages, adminSections }